import CustomTable from "components/CustomTable";
import { useEffect, useState } from "react";
import { Button, Col, Spinner, Row } from "react-bootstrap";
import {
  useEmandiLocationMasterQuery,
  useGetAllCommoditiesQuery,
  useGetAllMarketssQuery,
  useGetEmandiReportQuery,
  useEmandiLocationMasterDistrictQuery,
} from "../EMandiApiSlice";

import { setBreadcrumbs } from "app/appSlice";
import { selectCurrentRoles } from "features/auth/authSlice";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody } from "reactstrap";
import EmandiTrading from "./emandiTrading";
import { Mandi } from "./Mandi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
const EmandiReports = ({ isHCL = false, crop, firstState, firstDistrict }) => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [selectedCommodity, setSelectedCommodity] = useState(
    crop && isHCL ? crop : !crop && isHCL ? "" : isHCL ? "Mustard" : ""
    // isHCL ? (crop ? crop : "") : "Mustard"
  );

  const [selectedState, setSelectedState] = useState(
    firstState && isHCL
      ? firstState
      : !firstState && isHCL
      ? ""
      : isHCL
      ? "Uttar Pradesh"
      : ""
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    firstDistrict && isHCL
      ? firstDistrict
      : !firstDistrict && isHCL
      ? ""
      : isHCL
      ? "Prayagraj"
      : ""
    // firstDistrict
  );
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [marketList, setMarketList] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState([]);
  const [viewChart, setViewChart] = useState("");
  const [showErrorMessage, setErrorMessage] = useState(false);
  const [showMarketError, setShowMarketError] = useState(false);
  const [showCommodityError, setShowCommodityError] = useState(false);
  const [showDateError, setShowDateError] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [check, setCheck] = useState([]);
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [activeCard, setActiveCard] = useState(
    RolesFromToken?.realm_access?.roles.includes("FPO") ||
      RolesFromToken?.realm_access?.roles.includes("CBBO") ||
      isHCL
      ? "e-mandi"
      : "mandi"
  );

  const {
    data: data,
    isLoading,
    refetch,
    isFetching,
  } = useGetEmandiReportQuery({
    selectedState,
    selectedDistrict,
    selectedCommodity,
    selectedMarket,
    startDate,
    endDate,
    pagination,
  });

  const dateSet = new Set(data?.data?.results.map((item) => item.arrival_date));
  const sortedDates = Array.from(dateSet).sort(
    (a, b) => new Date(a) - new Date(b)
  );
  const groupedData = {};
  if (data?.data?.results && data.data.results[Symbol.iterator]) {
    for (const obj of data?.data?.results) {
      const market = obj.market;
      if (!groupedData[market]) {
        groupedData[market] = [];
      }
      groupedData[market].push(obj);
    }
  }
  const graphDict = [];
  for (const [market, dataPoints] of Object.entries(groupedData)) {
    const dataList = [];
    for (const date of sortedDates) {
      const dataPoint = dataPoints.find((item) => item.arrival_date === date);
      if (dataPoint) {
        dataList.push(dataPoint.modal_price);
      } else {
        dataList.push("");
      }
    }
    const entry = { name: market, data: dataList };
    graphDict.push(entry);
  }

  const { data: AllCommudity } = useGetAllCommoditiesQuery();
  const { data: AllMarkets } = useGetAllMarketssQuery({
    selectedState,
    selectedDistrict,
  });
  const { data: getStates } = useEmandiLocationMasterQuery();
  const { data: getDistrict } = useEmandiLocationMasterDistrictQuery(
    { selectedState },
    { skip: !selectedState }
  );

  var modelprices = [];
  useEffect(() => {
    users?.map((item) => {
      modelprices.push(item?.modal_price);
    });
  }, [data]);

  useEffect(() => {
    const uniqueDates = new Set();
    users?.forEach((item) => {
      uniqueDates.add(item?.arrival_date);
    });
    const uniqueDatesArray = Array.from(uniqueDates);
    setCheck(uniqueDatesArray);
  }, [users, data, startDate, endDate]);

  useEffect(() => {
    if (AllCommudity !== undefined) {
      setCommodityList(AllCommudity?.data);
    }
  }, [AllCommudity]);

  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data);
    }
  }, [getStates]);
  useEffect(() => {
    if (getDistrict !== undefined) {
      setDistrictList(getDistrict?.data);
    }
  }, [getDistrict]);

  useEffect(() => {
    if (AllMarkets && AllMarkets.data.length > 0) {
      const filterMarketNames = [];
      AllMarkets.data.map((page) =>
        filterMarketNames.push({ label: page.market, value: page.market })
      );
      setMarketList(filterMarketNames);
      setLoading(false);
    }
  }, [AllMarkets]);

  useEffect(() => {
    const dataFromApi = data?.data?.results ? data?.data.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;
    setUsers(dataFromApi);
    setPagination(paginationFromApi);
  }, [data]);

  useEffect(() => {
    const fetchedChartData = {
      series: graphDict,
      options: {
        chart: {
          type: "bar",
          height: 500,
        },
        xaxis: {
          categories: [...check],
        },
      },
    };
    setChartData(fetchedChartData);
  }, [data, startDate, endDate]);

  const columns = [
    {
      field: "Commodity",
      headerName: "Commodity",
      flex: 1, // Adjusts width dynamically
      minWidth: 170, // Ensures a minimum width
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "normal", // Allows text to wrap
            wordBreak: "break-word", // Breaks long words
          }}
        >
          <img
            src={params.row.media_url}
            alt="img"
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "50%",
              border: "1px solid #ddd",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
              marginRight: "8px",
            }}
          />
          <span style={{ maxWidth: "150px", wordBreak: "break-word" }}>
            {params.row.commodity}
          </span>
        </div>
      ),
    },

    { field: "state", headerName: "State", width: 140 },
    { field: "district", headerName: "District", width: 150 },
    { field: "variety", headerName: "Variety", width: 120 },
    { field: "market", headerName: "Market", width: 150 },
    { field: "arrival_date", headerName: "Arrival Date", width: 140 },
    { field: "min_price", headerName: "Min price", width: 120 },
    { field: "max_price", headerName: "Max price", width: 120 },
    { field: "modal_price", headerName: "Modal Price (₹/Qtl)", width: 180 },
  ];
  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading || isFetching,
  };

  const handleStartChange = (e) => {
    const newStartDate = e.target.value;
    if (!newStartDate) return;
    setStartDate(newStartDate);
    setEndDate(""); // reset end date when start date changes
    setPagination({ page: 1, pageCount: 0 });
  };

  const getMaxEndDate = () => {
    if (!startDate) return "";
    const max = new Date(startDate);
    max.setDate(max.getDate() + 6);
    return max.toISOString().split("T")[0];
  };

  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state,
        label: state.state,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList?.map((state) => {
      responseAgentArray.push({
        value: state.district,
        label: state.district,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const handleCommodityOptions = () => {
    let responseArray = [];
    commodityList?.map((item) => {
      responseArray.push({ label: item.commodity });
    });
    return responseArray;
  };
  const onCommodityChange = (selectedOption) => {
    setSelectedCommodity(selectedOption ? selectedOption.label : "");
    setShowCommodityError(false);
    setPagination({ page: 1, pageCount: 0 });
  };

  const onMarketChange = (event) => {
    const currentSelectedMarket = event?.map((item) => item.label);
    setSelectedMarket(JSON.stringify(currentSelectedMarket));
    setShowMarketError(false);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: 40,
      minHeight: 40,
      padding: "0px",
      fontSize: "13px",
      zIndex: 100,
    }),
  };

  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: "Trading", link: "" },
    ];

    dispatch(setBreadcrumbs(breadcrumbs));
  }, []);

  const handleClick = (event) => {
    if (selectedState == "") {
      setErrorMessage(true);
      return;
    } else if (selectedMarket == "") {
      setShowMarketError(true);
    } else if (selectedCommodity == "") {
      setShowCommodityError(true);
      return;
    } else if (startDate == "" && endDate == "") {
      setShowDateError(true);
      return;
    } else {
      setViewChart(event);
    }
  };
  const handleClick2 = (event) => {
    setViewChart(event);
  };
  const Navigate = useNavigate();
  const handleActiveCard = (cardName) => {
    Navigate(cardName);
  };
  const ReloadApplication = () => {
    setTimeout(() => {
      refetch();
    }, 1500);
  };

  return (
    <>
      {RolesFromToken?.realm_access?.roles.includes("CBBO") ||
      RolesFromToken?.realm_access?.roles.includes("FPO") ||
      isHCL ? (
        ""
      ) : (
        <div className="radio-inputs" style={{ marginTop: "-10px" }}>
          <label className="radio">
            <div onClick={() => setActiveCard("mandi")}>
              <input
                type="radio"
                name="radio"
                checked={activeCard === "mandi" ? true : false}
              />
              <span
                className={`name ${
                  activeCard === "mandi" ? "fw-bold text-primary" : "fw-bold"
                }`}
              >
                E-mandi
              </span>
            </div>
          </label>
          <label className="radio">
            <div onClick={() => setActiveCard("e-mandi")}>
              <input
                type="radio"
                name="radio"
                checked={activeCard === "e-mandi" ? true : false}
              />
              <span
                className={`name ${
                  activeCard === "e-mandi" ? "fw-bold text-primary" : "fw-bold"
                }`}
              >
                E-mandi Live Prices
              </span>
            </div>
          </label>
          {RolesFromToken?.realm_access?.roles.includes("FPO") ? (
            ""
          ) : (
            <label className="radio">
              <div onClick={() => handleActiveCard(`/trades`)}>
                <input
                  type="radio"
                  name="radio"
                  checked={activeCard === "dashboardLayout" ? true : false}
                />
                <span
                  className={`name ${
                    activeCard === "dashboardLayout"
                      ? "fw-bold text-primary"
                      : "fw-bold"
                  }`}
                >
                  Dashboard
                </span>
              </div>
            </label>
          )}
          <label className="radio">
            <div onClick={() => handleActiveCard(`/priceTrends`)}>
              <input
                type="radio"
                name="radio"
                checked={activeCard === "priceTrends" ? true : false}
              />
              <span
                className={`name ${
                  activeCard === "priceTrends"
                    ? "fw-bold text-primary"
                    : "fw-bold"
                }`}
              >
                Price Trends
              </span>
            </div>
          </label>
        </div>
      )}
      {activeCard === "e-mandi" ? (
        <Card className="transparent_card">
          <CardBody className="p-1 p-lg-3">
            {isHCL && (
              <Row className="mt-1 px-1">
                <Col
                  xs="6"
                  md="6"
                  lg="3"
                  className="d-flex justify-content-start"
                >
                  <Select
                    menuPlacement="auto"
                    value={
                      selectedCommodity
                        ? { label: selectedCommodity, value: selectedCommodity }
                        : null
                    }
                    placeholder="Select Commodity..."
                    options={handleCommodityOptions()}
                    onChange={onCommodityChange}
                    isClearable={true}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minWidth: "200px",
                        width: "100%",
                        maxWidth: "250px",
                      }),
                      input: (base) => ({
                        ...base,
                        width: "100%",
                        minWidth: "100%",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        overflow: "hidden",
                      }),
                    }}
                  />
                </Col>
                <Col xs="6" md="6" lg="3" className="offset-md-6">
                  <div className="mt-2 d-flex justify-content-end">
                    <div className="mt-1">
                      Total :
                      <span className="text-success">
                        &nbsp;{data?.data?.total}
                      </span>
                    </div>
                    <Button
                      className="bg-transparent text-black fs-6  reloadButton  mx-3"
                      size="sm"
                      onClick={ReloadApplication}
                    >
                      <FontAwesomeIcon icon={faRotateLeft} />
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            {!isHCL && (
              <>
                <div className="row ">
                  <Col lg="2" xs="6">
                    <div className="d-flex justify-content-between">
                      <label className="text-gray mb-1 mt-1">State</label>
                      {selectedState &&
                        ((typeof selectedState === "string" &&
                          selectedState !== "") ||
                          (Array.isArray(selectedState) &&
                            selectedState.length > 0)) && (
                          <span
                            className="mdi mdi-close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedState("");
                              setSelectedMarket([]);
                            }}
                          ></span>
                        )}
                    </div>
                    <Select
                      placeholder="Select.."
                      options={handleStateOptions()}
                      value={
                        selectedState
                          ? handleStateOptions().find(
                              (opt) => opt.value === selectedState
                            )
                          : null
                      }
                      onChange={(option) => {
                        setSelectedState(option ? option.value : "");
                        setPagination({ page: 1, pageCount: 0 });
                      }}
                      styles={customStyles}
                      // isClearable
                    />
                    {showErrorMessage && (
                      <span style={{ color: "red" }}>Please Select State</span>
                    )}
                  </Col>
                  <Col lg="2" xs="6">
                    <div className="d-flex justify-content-between">
                      <label className="text-gray mb-1 mt-1">District</label>
                      {selectedDistrict &&
                        ((typeof selectedDistrict === "string" &&
                          selectedDistrict !== "") ||
                          (Array.isArray(selectedDistrict) &&
                            selectedDistrict.length > 0)) && (
                          <span
                            className="mdi mdi-close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedDistrict("");
                              setSelectedMarket([]);
                            }}
                          ></span>
                        )}
                    </div>
                    <Select
                      placeholder="Select.."
                      options={handleDistrictOptions()}
                      value={
                        selectedDistrict
                          ? handleDistrictOptions().find(
                              (opt) => opt.value === selectedDistrict
                            )
                          : null
                      }
                      onChange={(option) => {
                        setSelectedDistrict(option ? option.value : "");
                        setPagination({ page: 1, pageCount: 0 });
                      }}
                      styles={customStyles}
                    />

                    {showErrorMessage && (
                      <span style={{ color: "red" }}>Please Select State</span>
                    )}
                  </Col>

                  <Col lg="2" xs="6" className="mt-lg-0 mt-md-0 ">
                    <div className="d-flex justify-content-between">
                      <label className="text-gray mb-1 mt-1"> Commodity</label>
                      {selectedCommodity !== "" ? (
                        <span
                          className="mdi mdi-close"
                          onClick={() => setSelectedCommodity("")}
                        ></span>
                      ) : (
                        ""
                      )}
                    </div>
                    <Select
                      value={selectedCommodity}
                      placeholder={
                        selectedCommodity === ""
                          ? "Select..."
                          : selectedCommodity
                      }
                      options={handleCommodityOptions()}
                      onChange={onCommodityChange}
                      styles={customStyles}
                      className=""
                    />
                    {showCommodityError ? (
                      <span style={{ color: "red" }}>
                        Please Select Commodity{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col lg="2">
                    <div className="d-flex justify-content-between mt-lg-0 mt-md-0 mt-2">
                      <label className="text-gray mb-1 mt-1"> Market</label>
                    </div>
                    <Select
                      isMulti={true}
                      isLoading={Loading}
                      options={marketList}
                      onChange={onMarketChange}
                      styles={customStyles}
                    />
                    {showMarketError ? (
                      <span style={{ color: "red" }}>
                        Please Select Market{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </Col>

                  <Col lg="2" xs="6" md="3" className="mt-lg-0 mt-md-0 mt-2 ">
                    <div className="d-flex justify-content-between">
                      <label className="text-gray mb-1 d-block mt-1">
                        Date From
                      </label>
                      {startDate !== "" ? (
                        <span
                          className="mdi mdi-close"
                          onClick={() => setStartDate("")}
                        ></span>
                      ) : (
                        ""
                      )}
                    </div>
                    <input
                      type="date"
                      className="inputBoxCss w-100"
                      style={{
                        border: "1px solid #ced4da",
                        color: "grey",
                        height: "40px",
                      }}
                      value={startDate}
                      onChange={handleStartChange}
                    ></input>
                    {showDateError ? (
                      <p style={{ color: "red" }}> Please Select Date </p>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col lg="2" xs="6" md="3" className="mt-lg-0 mt-md-0 mt-2">
                    <div className="d-flex justify-content-between">
                      <label className="text-gray mb-1 d-block mx-3 mt-1">
                        Date To
                      </label>
                      {endDate !== "" ? (
                        <span
                          className="mdi mdi-close"
                          onClick={() => setEndDate("")}
                        ></span>
                      ) : (
                        ""
                      )}
                    </div>
                    <input
                      type="date"
                      className="inputBoxCss w-100"
                      style={{
                        border: "1px solid #ced4da",
                        color: "grey",
                        height: "40px",
                      }}
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                        setPagination({ page: 1, pageCount: 0 });
                      }}
                      min={startDate}
                      max={getMaxEndDate()}
                      disabled={!startDate}
                    ></input>
                    {showDateError ? (
                      <p style={{ color: "red" }}> Please Select Date </p>
                    ) : (
                      ""
                    )}
                  </Col>
                </div>
                <div className="row">
                  <Col
                    lg="1"
                    sm="12"
                    xs="12"
                    md="3"
                    className="mt-lg-1 mt-md-0 mt-2 offset-md-11"
                  >
                    <div className="text-center float-end">
                      {viewChart !== "chart" ? (
                        <Button
                          className="mt-4 float-end"
                          style={{ padding: "12px" }}
                          onClick={() => handleClick("chart")}
                        >
                          View Data
                        </Button>
                      ) : (
                        <Button
                          className="mt-4"
                          onClick={() => handleClick2("list")}
                        >
                          View List
                        </Button>
                      )}
                    </div>
                  </Col>
                </div>
              </>
            )}
            <hr />
            {viewChart === "chart" ? (
              <div className="mt-3">
                <ReactApexChart
                  options={chartData.options}
                  series={chartData.series}
                  type="bar"
                  height={420}
                />
              </div>
            ) : (
              <div>
                <div
                  style={{ marginTop: "-2%" }}
                  className="d-lg-block d-md-block d-none"
                >
                  <CustomTable
                    rows={tableData.rows}
                    columns={tableData.columns}
                    paginationState={tableData.paginationState}
                    loading={tableData.isLoading || tableData.isFetching}
                    checkboxShowFalse={true}
                  />
                </div>
                <div className="d-lg-none d-md-none d-block">
                  <div className=" ">
                    {isLoading ? (
                      <div className="d-flex justify-content-center py-4">
                        <Spinner animation="border" />
                      </div>
                    ) : users?.length === 0 ? (
                      <div className="d-flex justify-content-center py-4">
                        <h5>No Data Available</h5>
                      </div>
                    ) : (
                      users?.map((item, id) => {
                        return (
                          <div key={id} className="col-12 card">
                            <div className="card-body p-4">
                              <div
                                className="d-flex align-items-center py-2 gap-3"
                                style={{ borderBottom: "1px solid #ebeaeab5" }}
                              >
                                <img
                                  src={item?.media_url}
                                  style={{
                                    height: "50px",
                                    width: "50px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                                <div className="">
                                  <h5 className="text-success">
                                    {item.commodity}
                                  </h5>
                                  <div className="d-flex gap-1">
                                    <h6 style={{ color: "#9c9c9c" }}>
                                      Arrival Date :
                                    </h6>{" "}
                                    <span className="text-orange">
                                      {item.arrival_date}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between mt-2">
                                <div className="">
                                  <h6>State</h6> {item.state}
                                </div>
                                <div className="">
                                  <h6>District</h6> {item.district}
                                </div>
                                <div className="">
                                  <h6>Market</h6> {item.market}
                                </div>
                              </div>
                              <hr className="my-2 m-0"></hr>
                              <div className="d-flex justify-content-between ">
                                <div className="">
                                  <h6>Min Price</h6> ₹ {item.min_price}
                                </div>
                                <div className="">
                                  <h6>Max Price</h6> ₹ {item.max_price}
                                </div>
                                <div className="">
                                  <h6>Modal Price</h6> ₹ {item.modal_price}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      ) : activeCard === "Trading" ? (
        <div className="mt-3">
          <EmandiTrading />
        </div>
      ) : activeCard === "mandi" ? (
        <Mandi />
      ) : (
        ""
      )}
    </>
  );
};

export default EmandiReports;
